import React, { useEffect, useState } from 'react'
import { PRIVATE_PATHS, redirect } from 'utils/paths'
import styled from 'styled-components'
import { ReactComponent as BasketIcon } from 'assets/images/basket.svg'
import { getCart } from 'utils/localStorage'
import { cartEmitter } from 'utils/emitters'
import { uniq } from 'ramda'

const CartIcon = ({ isMobile = false, passive = false }) => {
  const [itemsInCart, setItemsInCart] = useState(0)

  const countCartItems = () => {
    const cart = getCart()
    setItemsInCart(uniq(cart).length)
  }

  useEffect(() => {
    countCartItems()
    cartEmitter.on('cart-change', countCartItems)
    cartEmitter.on('count-cart-items', countCartItems)
    return () => {
      cartEmitter.off('cart-change', countCartItems)
      cartEmitter.off('count-cart-items', countCartItems)
    }
  }, [])

  return (
    <IconWrapper>
      <BasketIcon aria-hidden={passive ? 'true' : undefined} onClick={passive ? undefined : () => redirect(PRIVATE_PATHS.cart)} />
      {
        itemsInCart > 0 && (
          <Badge
            onClick={passive ? undefined : () => redirect(PRIVATE_PATHS.cart)}
            $isMobile={isMobile}
          >
            {itemsInCart}
          </Badge>
        )
      }
    </IconWrapper>
  )
}

export default CartIcon

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;

  &:hover {
    svg {
      g {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`

const Badge = styled.div`
  position: absolute;
  top: ${({ $isMobile }) => ($isMobile ? '-6px' : '-8px')};
  right: ${({ $isMobile }) => ($isMobile ? '-8px' : '-10px')};
  min-width: ${({ $isMobile }) => ($isMobile ? '16px' : '18px')};
  height: ${({ $isMobile }) => ($isMobile ? '16px' : '18px')};
  padding: ${({ $isMobile }) => ($isMobile ? '0 4px' : '0 5px')};
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.primary};
  box-shadow: 0 2px 8px rgba(210, 71, 36, 0.35);
  font-size: ${({ $isMobile }) => ($isMobile ? '9px' : '10px')};
  font-weight: 700;
  line-height: 1;
  z-index: 2;
`
